import api from '../client';

const apiKeyService = {
  list: async () => {
    const response = await api.get('/api-keys/');
    return response.data;
  },

  create: async ({ name, project = null, workspace = null }) => {
    const response = await api.post('/api-keys/', { name, project, workspace });
    return response.data; // includes `key` field — shown once
  },

  revoke: async (id) => {
    await api.post(`/api-keys/${id}/revoke/`);
  },
};

export default apiKeyService;
